export default "__VITE_ASSET__LQFEyKtJ__"